import { memo } from 'react';
import {
  CenteredColumnContainer,
  CircleText,
  CircleWrapper,
  ContentText,
  ContentTitle,
} from '.';

interface ConnectingCardProps {
  circleText: string;
  cardTitle: string;
  cardText: string;
}
export const ConnectingCard = memo(
  ({ circleText, cardTitle, cardText }: ConnectingCardProps) => {
    return (
      <CenteredColumnContainer>
        <CircleWrapper component="span">
          <CircleText variant="body1" color="textPrimary">
            {circleText}
          </CircleText>
        </CircleWrapper>

        <ContentTitle textAlign="center">{cardTitle}</ContentTitle>

        <ContentText textAlign="justify">{cardText}</ContentText>
      </CenteredColumnContainer>
    );
  }
);
ConnectingCard.displayName = 'ConnectingCard';
